import React from "react";
import {AppBar, Button, Container, IconButton, Menu, MenuItem, Snackbar, useTheme} from "@material-ui/core";
import SignIn from "./screens/SignIn";
import Check from "./screens/Check";
import Rest from "../helpers/Rest";
import useStyles from "./styles"
import AllWhite from "../components/AllWhite";
import {setLoginPath} from "../pages/newLogin";
import ReportAnIssue from "./ReportAnIssue";
import {useParams} from "react-router-dom";
import {Alert} from "@material-ui/lab";
import {MenuSharp} from "@material-ui/icons";

const ACTIVE_PDU_KEY = "ACTIVE_PDU"

function getActive() {
    const pdu = window.localStorage.getItem(ACTIVE_PDU_KEY)
    if (pdu){
        return JSON.parse(pdu)
    }
}

function setActive(qrCode, id){
    window.localStorage.setItem(ACTIVE_PDU_KEY, JSON.stringify({
        qrCode: qrCode,
        id: id
    }))
}

function clearActive(){
    window.localStorage.removeItem(ACTIVE_PDU_KEY)
}

function getUrl(qrCode, id){
    return `registration/${qrCode}/${id}`
}

const NO = 0, SIGNING = 1, CHECKING = 2

class Pdu extends React.Component{
    constructor(props){
        super(props)
        const active = getActive()
        this.state = {
            validated: false,
            minHeight: 0,
            loading: active ? CHECKING : NO,
            reportingIssue: false
        }
        if (active) {
            this.checkIfSignedIn(active)
        }
        this.openMenu = e => this.setState({anchorEl: e.currentTarget})
        this.closeMenu = () => this.setState({anchorEl: null})
        this.goToDashboard = () => {
            const {device} = this.state
            document.location.href = `/dashboard/${device ? device.customer_id + '/': ''}`
        }
        this.edit = () => {
            const {device} = this.state
            if (!device){
                document.location.href = `/dashboard/`
            }
            else if (Rest.isAdmin) {
                const path = '/app/edit-device'
                setLoginPath(path)
                this.props.history.push({
                    pathname: path,
                    search: `qr_code=${this.props.qrCode}`
                })
            }
            else{
                document.location.href = `/dashboard/${device.customer_id}/device/${device.id}`
            }
        }
        this.reportAnIssue = () => this.setState({
            reportingIssue: true,
            anchorEl: null
        })
    }

    checkIfSignedIn(active){
        const url = getUrl(active.qrCode, active.id)
        Rest.get(url).then(reply => {
            if (!reply.return_time){
                if (active.qrCode !== this.props.qrCode){
                    Rest.del(url).then(() => {
                        clearActive()
                        this.setState({
                            loading: NO
                        })
                    })
                }
                else{
                    this.setState({
                        id: active.id,
                        loading: NO
                    })
                }
            }
        }).catch(() => {
            clearActive()
            this.setState({
                id: null,
                loading: NO
            })
        })
    }

    signOut(){
        this.setState({
            loading: SIGNING
        })
        Rest.del(getUrl(this.props.qrCode, this.state.id)).then(() => {
            clearActive()
            this.setState({
                loading: NO
            })
            this.props.history.push("/signed-out")
        })
    }

    signIn(){
        this.setState({
            loading: SIGNING
        })
        this.state.submit().then(id => {
            setActive(this.props.qrCode, id)
            this.setState({
                id: id,
                loading: NO
            })
        })
    }

    submit(){
        if (this.state.id){
            this.signOut()
        }
        else if (this.state.submit){
            this.signIn()
        }
    }

    button(){
        switch (this.state.loading){
            case SIGNING:
                return <div>Signing {this.state.id ? 'out' : 'in'}...</div>
            case CHECKING:
                return <div>Checking...</div>
            default:
                return (
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={this.submit.bind(this)}
                        disabled={!(this.state.validated || this.state.id)}
                    >Sign {this.state.id ? "Out" : "In"}</Button>
                )
        }
    }

    componentDidMount() {
        if (!Rest.getUser()){
            return
        }
        Rest.get("dashboard/device/qr/" + this.props.qrCode).then(reply => this.setState({
            device: reply
        }))
    }

    content(){
        if (this.state.loading){
            return <></>
        }
        if (this.state.id){
            return <Check qrCode={this.props.qrCode}/>
        }
        return (
            <SignIn
                qrCode={this.props.qrCode}
                onValidationStateChanged={state => this.setState({
                    validated: state
                })}
                onInitialized={(handler, validated) => this.setState({
                    submit: handler,
                    validated: validated
                })}
            />
        )
    }

    menu(){
        const {anchorEl} = this.state
        const open = !!anchorEl

        return <>
            <IconButton
                id="pdu-menu-button"
                aria-controls={open ? 'pdu-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={this.openMenu}
            >
                <MenuSharp/>
            </IconButton>
            <Menu
                id="pdu-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={this.closeMenu}
                MenuListProps={{
                    'aria-labelledby': 'pdu-menu-button',
                }}
            >
                <MenuItem onClick={this.goToDashboard}>Go to dashboard</MenuItem>
                <MenuItem onClick={this.reportAnIssue}>Report an issue</MenuItem>
                <MenuItem onClick={this.edit}>Edit</MenuItem>
            </Menu>
        </>
    }

    render(){
        return (
            <AllWhite>
                <AppBar position="fixed">
                    <div className={this.props.classes.buttons}>
                        {this.menu()}
                        {this.button()}
                    </div>
                </AppBar>
                <Container maxWidth="xs" style={{paddingTop: 64}}>
                    {this.content()}
                </Container>
                <ReportAnIssue
                    qrCode={this.props.qrCode}
                    open={this.state.reportingIssue}
                    onClose={() => this.setState({
                        reportingIssue: false
                    })}
                    onSent={() => this.setState({
                        reportSent: true
                    })}
                    onError={error => this.setState({
                        error: error
                    })}
                />
                <Snackbar open={!!this.state.reportSent} onClose={() => this.setState({
                    reportSent: false
                })}>
                    <Alert severity="success">Report has been sent</Alert>
                </Snackbar>
                <Snackbar open={!!this.state.error} onClose={() => this.setState({
                    error: false
                })}>
                    <Alert severity="error">{this.state.error}</Alert>
                </Snackbar>
            </AllWhite>
        )
    }
}

export default function(props){
    const classes = useStyles(useTheme())
    const {qrCode} = useParams()
    return <Pdu classes={classes} qrCode={qrCode} {...props}/>
}
